/**
 * Show buy-votes when wallet is empty and the user hit the daily free vote cap
 * for this competition.
 */
export function shouldShowBuyVotes({
  votePurchase,
  remainingVotes = 0,
  maxFreeVotesPerDay = 1,
  dailyVotesUsed = 0,
}) {
  if (!votePurchase) return false;
  if (Number(remainingVotes) > 0) return false;
  const max = Math.max(1, Number(maxFreeVotesPerDay) || 1);
  return Number(dailyVotesUsed) >= max;
}

export function shouldShowBuyVotesAnywhere({
  votePurchase,
  remainingVotes = 0,
  maxFreeVotesPerDay = 1,
  dailyVotesUsed = 0,
}) {
  return shouldShowBuyVotes({
    votePurchase,
    remainingVotes,
    maxFreeVotesPerDay,
    dailyVotesUsed,
  });
}

export function resolveMaxFreeVotesPerDay(competition) {
  if (!competition) return 1;
  const raw =
    competition.max_free_votes_per_day ?? competition.max_votes_per_event ?? 1;
  return Math.max(1, Number(raw) || 1);
}

export function isPurchaseRequiredMessage(message = "") {
  return /purchase votes/i.test(String(message));
}

/** Active processor for vote packs. Default PayPal until Stripe is restored. */
export function getVotePaymentProvider(votePurchase) {
  const fromApi = String(votePurchase?.provider || "").toLowerCase();
  if (fromApi === "stripe" || fromApi === "paypal") return fromApi;
  const fromEnv = String(
    process.env.REACT_APP_VOTE_PAYMENT_PROVIDER || "paypal"
  ).toLowerCase();
  return fromEnv === "stripe" ? "stripe" : "paypal";
}

export function votePaymentProviderLabel(votePurchase) {
  return getVotePaymentProvider(votePurchase) === "stripe" ? "Stripe" : "PayPal";
}

/** Success toast after vote pack checkout (Stripe or PayPal). */
export function formatVotePurchaseSuccessMessage(res, competitionName = "") {
  if (res?.message) return res.message;

  const name = competitionName || res?.data?.competitionName || "";
  const votes = Number(res?.data?.votesPurchased);
  const votesLabel = Number.isFinite(votes) && votes > 0
    ? `${votes} vote${votes === 1 ? "" : "s"}`
    : "Votes";

  if (name) {
    return `Payment successful! ${votesLabel} added to your wallet for ${name}.`;
  }
  return `${votesLabel} added to your wallet.`;
}

/** Stripe uses session_id; PayPal also appends token=ORDER_ID on return. */
export function resolveVotePurchaseSessionId(params) {
  if (!params) return "";
  return (
    params.get("session_id") ||
    params.get("token") ||
    params.get("orderId") ||
    ""
  );
}
